import { Grid } from "@mui/material";
import React from "react";
import { AnalyticsContext } from "../context/analyticsContext";
import { ISearchParameter } from "../interface/iSearchParameter";
import SelectCoachInput from "../../../../components/inputs/coach/selectCoachInput";
import InputDate from "../../../../components/inputs/date/inputDate";
import SearchButton from "../../../../components/inputs/searchButton/searchButton";

const SearchForm = (): React.JSX.Element => {
  const {
    setSearchParameter,
    searchParameter,
    isLoading,
    handleSearch,
  }: {
    setSearchParameter: (searchParameter: ISearchParameter) => void;
    searchParameter: ISearchParameter;
    isLoading: boolean;
    handleSearch: () => void;
  } = React.useContext(AnalyticsContext);

  const handleSelectCoach = (
    e: null | { label: string; value: string }
  ): void => {
    setSearchParameter({
      ...searchParameter,
      coach: e,
    });
  };

  const handleSetFromDate = (date: string): void =>
    setSearchParameter({
      ...searchParameter,
      fromDate: date,
    });

  const handleSetTillDate = (date: string): void =>
    setSearchParameter({
      ...searchParameter,
      tillDate: date,
    });

  const handleDisableSearchButton = (): boolean =>
    searchParameter.coach === null ||
    isLoading ||
    searchParameter.fromDate === "" ||
    searchParameter.tillDate === "";

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch();
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={4}>
          <SelectCoachInput
            disabled={isLoading}
            error
            required
            coach={searchParameter.coach}
            setCoach={handleSelectCoach}
          />
        </Grid>
        <Grid item xs={6} sm={4} md={3}>
          <InputDate
            disabled={isLoading}
            label="Start"
            error
            required
            date={searchParameter.fromDate}
            setDate={handleSetFromDate}
          />
        </Grid>
        <Grid item xs={6} sm={4} md={3}>
          <InputDate
            disabled={isLoading}
            label="Ende"
            error
            required
            date={searchParameter.tillDate}
            setDate={handleSetTillDate}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <SearchButton
            disabled={handleDisableSearchButton()}
            isLoading={isLoading}
            onClick={handleSearch}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default SearchForm;
